import React, {useContext, useState} from 'react';
import Button from "@amzn/meridian/button";
import {FormattedMessage, injectIntl} from "react-intl";
import Row from "@amzn/meridian/row";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Select, {SelectOption} from "@amzn/meridian/select";
import escapeRegExp from "lodash/escapeRegExp"
import {DraftContext} from "../../../draftSave/context/DraftSaveContext";
import {CONFIG_TYPE} from "../../../util/Constants";
import Icon from "@amzn/meridian/icon";
import trashTokens from "@amzn/meridian-tokens/base/icon/trash";

const DeleteAdtaSorterConfigurationModal = (props) => {

    const {formatMessage} = props.intl;
    const {mac} = props;
    const {getDraftData, deleteInstance, deleteAll} = useContext(DraftContext);
    const {open, setOpen} = props;
    const [bayId, setBayId] = useState("")
    const [searchQuery, setSearchQuery] = useState("")

    const onCloseModal = () => {
        setOpen(false);
        resetInputState();
    }

    const stateValues = {
        bayId: bayId,
        mac: mac
    }

    const sorterConfigList = getDraftData({stateKey: CONFIG_TYPE.SORTER_DESTINATION, subKey: mac}).map(({bayId}) => bayId);
    const searchRegExp = new RegExp(escapeRegExp(searchQuery), "i")

    // Converting to set to remove non-unique bay ids from DDB form
    const matchedOptions = [...new Set(sorterConfigList.filter(
        option => !searchQuery || searchRegExp.test(option)
    ))]

    const onClickConfirm = (stateValues) => {
        deleteData(stateValues);
        setOpen(false)
        resetInputState();
    }

    function resetInputState() {
        setBayId("");
    }

    const deleteData = (stateValues) => {
        deleteInstance({
            stateKey: CONFIG_TYPE.SORTER_DESTINATION,
            subKey: stateValues.mac,
            keyComparator: (instance) => (instance.bayId === stateValues.bayId)
        })
    }

    return (
        <Row>
            <Modal
                title={formatMessage({id: "device.delete_config_button_modal"})}
                open={open}
                onClose={onCloseModal}
                scrollContainer="viewport"
                closeLabel="Close"
                bodySpacingInset="medium">
                <Column>
                    <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                        <FormattedMessage id="modal.bayiddelete"
                                          defaultMessage="Please select the Bay Id you would like to remove:"/>
                    </Text>
                    <Select
                        value={bayId}
                        onChange={setBayId}
                        searchQuery={searchQuery}
                        onSearch={setSearchQuery}
                        placeholder={<FormattedMessage id="modal.selectbayid"
                                   defaultMessage="Select bay ID"/>}
                        width="100%">
                        {matchedOptions.map((bayId) => (
                            <SelectOption key={bayId} value={bayId} label={bayId}/>
                        ))}
                        {!matchedOptions.length ? (
                            <Column alignmentVertical="center" spacing="100" spacingInset="100">
                                {sorterConfigList ? <Text alignment="center"> No matching bay IDs </Text>
                                    : <Text alignment="center"> No bay IDs available </Text>}
                            </Column>) : null}
                    </Select>
                </Column>
                <ModalFooter>
                    <Row alignmentHorizontal="justify" widths="fit">
                        <Button
                            size="small"
                            className="redBtn"
                            onClick={() => {
                                deleteAll({stateKey: CONFIG_TYPE.SORTER_DESTINATION, subKey: stateValues.mac});
                                onCloseModal();
                            }}
                        >
                            <Icon tokens={trashTokens} />
                            <FormattedMessage id="modal.deleteAll" defaultMessage="Delete All"/>
                        </Button>
                        <Row alignmentHorizontal="right" widths="fit">
                            <Button type="secondary" size="small" onClick={onCloseModal}>
                                <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                            </Button>
                            <Button type="primary" size="small" onClick={() => onClickConfirm(stateValues)}>
                                <FormattedMessage id="modal.confirm" defaultMessage="Confirm"/>
                            </Button>
                        </Row>
                    </Row>
                </ModalFooter>
            </Modal>
        </Row>
    )
}

export default injectIntl(DeleteAdtaSorterConfigurationModal);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtadevice/modal/DeleteAdtaSorterConfigurationModal.js